module.exports = __webpack_public_path__ + "assets/web.4a6e920d.svg";